import { render, staticRenderFns } from "./TokenPage.vue?vue&type=template&id=509d277a&scoped=true&"
import script from "./TokenPage.vue?vue&type=script&lang=ts&"
export * from "./TokenPage.vue?vue&type=script&lang=ts&"
import style0 from "./TokenPage.vue?vue&type=style&index=0&id=509d277a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509d277a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VRadio,VRadioGroup,VTextField})
